module.exports = __webpack_public_path__ + "static/img/case-dy-page-bg-04.0011a74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dy/case-dy-page-bg-04.jpg
// module id = 4Num
// module chunks = 1